<template>
  <div class="login-container">
    <img class="login" :src="login" alt="药聚汇">
    <div class="login-box">
      <div class="logo-header">
        <img class="logo" :src="logo" alt="药聚汇">
      </div>
      <login-form></login-form>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/login_title.png'
import login from '@/assets/login.png'
import loginForm from './components/loginForm'
export default {
  name: 'login',
  data() {
    return {
      type: '',
      logo,
      login
    }
  },
  components: {
    loginForm
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped="">
  @import '@/styles/login.scss';
  .login-return {
    position: absolute;
    top: 20px;
    left: 30px;
    color: #fff;
    font-size: 14px;
    width: 101px;
    height: 28px;
    line-height: 26px;
    border: 1px solid rgba(253,253,253,1);
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #fff;
      color: #1881dc;
    }
  }
  .login-box {
    height: 518px;
    width: 420px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-210px, -259px);
  }
  .logo-header {
    margin-bottom: 60px;
    text-align: center;
  }
  .login {
    width: 100%;
    height: 100%;
  }
</style>
